/**
 * Shared types and fetch helper for the player column system.
 *
 * `fetchFileData(fileId, linkId?)` wraps `GET /file/{id}` and returns the
 * typed response. `PlayerColumn` owns fetching and rendering into each
 * column's DOM — this module only provides the types, the fetch helper,
 * and a `window.loadFile` shim that routes through `playerColumnManager`
 * so page-level callers (prev/next buttons, search results, comments
 * code, etc.) can switch the active column by file id.
 */
// ── Fetch helper ──
export async function fetchFileData(fileId, linkId) {
    let url = `/file/${fileId}`;
    if (linkId)
        url += `?link_id=${encodeURIComponent(linkId)}`;
    const response = await fetch(url, {});
    if (!response.ok) {
        let errorMessage = `${response.status} ${response.statusText}`;
        try {
            const body = await response.json();
            if (body?.error)
                errorMessage = body.error;
        }
        catch {
            // Response body wasn't JSON — use status text
        }
        throw new Error(errorMessage);
    }
    return response.json();
}
// ── window.loadFile shim ──
//
// Routes through playerColumnManager so page-level callers work correctly
// in the multi-column layout. The active column is determined by
// `playerColumns.loadFileIntoActiveColumn`.
export function loadFile(fileId) {
    const w = window;
    if (w.playerColumns && typeof w.playerColumns.loadFileIntoActiveColumn === 'function') {
        w.playerColumns.loadFileIntoActiveColumn(fileId);
        return;
    }
    console.warn('loadFile called before playerColumns initialized');
}
if (typeof window !== 'undefined') {
    window.loadFile = loadFile;
}
